import {PriceModel} from '../Price.model';
import {AdditionalFee as AdditionalFeeV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2AdditionalFee as AdditionalFee} from '@wix/auto_sdk_ecom_cart-v-2';
import {ModelContext} from '../../../types/app.types';

export class AdditionalFeeModel {
  public code: string;
  public name: string;
  public price: PriceModel;

  constructor(params: AdditionalFeeModel) {
    this.code = params.code;
    this.name = params.name;
    this.price = params.price;
  }

  public static fromCartV1(additionalFee: AdditionalFeeV1, modelContext: ModelContext) {
    return new AdditionalFeeModel({
      code: additionalFee.code,
      name: additionalFee.translatedName ?? additionalFee.name,
      price: PriceModel.fromCartV1(additionalFee.price, modelContext),
    });
  }

  /* istanbul ignore next */
  public static fromCartV2(additionalFee: AdditionalFee, modelContext: ModelContext): AdditionalFeeModel {
    return new AdditionalFeeModel({
      code: additionalFee.code,
      name: additionalFee.name?.translated ?? additionalFee.name?.original ?? '',
      price: PriceModel.fromCartV2(additionalFee.price, modelContext),
    });
  }
}
